function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { LOAD_QUALIFICATIONS_REQUEST, LOAD_QUALIFICATIONS_SUCCESS, LOAD_QUALIFICATIONS_FAILURE, LOAD_QUALIFICATION_REQUEST, LOAD_QUALIFICATION_SUCCESS, LOAD_QUALIFICATION_FAILURE, LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE, LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS, LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST, RESET_CURRENT_CAMPAIGN, LOAD_DEVELOPER_QUALIFICATIONS_REQUEST, LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS, LOAD_DEVELOPER_QUALIFICATIONS_FAILURE } from '../ActionType';
var initialState = {
    currentTargetingByCountryLanguage: null,
    currentTargetingByCountryLanguageLoading: true,
    currentTargetingByCountryLanguageError: '',
    targetingByCountryLanguage: {},
    targetingByCountryLanguageLoading: true,
    targetingByCountryLanguageError: '',
    currentQualificationById: null,
    currentQualificationByIdLoading: true,
    currentQualificationByIdError: '',
    qualificationsById: {},
    qualificationsByIdLoading: true,
    qualificationsByIdError: '',
    developerQualifications: [],
    developerQualificationsLoading: true,
    developerQualificationsError: ''
};
export var getCurrentQualification = function(state) {
    return {
        data: state.qualification.qualificationsById[state.qualification.currentQualificationById],
        loading: state.qualification.currentQualificationByIdLoading,
        error: state.qualification.currentQualificationByIdError
    };
};
export var getCurrentTargetingByCountryLanguage = function(state) {
    return {
        data: state.qualification.currentTargetingByCountryLanguage && state.qualification.targetingByCountryLanguage["".concat(state.qualification.currentTargetingByCountryLanguage.countryId, "-").concat(state.qualification.currentTargetingByCountryLanguage.languageId)],
        loading: state.qualification.currentTargetingByCountryLanguageLoading,
        error: state.qualification.currentTargetingByCountryLanguageError
    };
};
export var getQualifications = function(state) {
    return {
        data: state.qualification.qualificationsById,
        loading: state.qualification.qualificationsByIdLoading,
        error: state.qualification.qualificationsByIdError
    };
};
export var getDeveloperQualifications = function(state) {
    return {
        data: state.qualification.developerQualifications,
        loading: state.qualification.developerQualificationsLoading,
        error: state.qualification.developerQualificationsError
    };
};
export default function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case RESET_CURRENT_CAMPAIGN:
            {
                return _object_spread_props(_object_spread({}, state), {
                    currentQualificationByIdLoading: true,
                    currentQualificationByIdError: '',
                    currentQualificationById: null,
                    currentTargetingByCountryLanguage: null,
                    currentTargetingByCountryLanguageLoading: true,
                    currentTargetingByCountryLanguageError: ''
                });
            }
        case LOAD_QUALIFICATION_REQUEST:
            {
                var id = action.payload.id;
                return _object_spread_props(_object_spread({}, state), {
                    currentQualificationByIdLoading: true,
                    currentQualificationByIdError: '',
                    currentQualificationById: id
                });
            }
        case LOAD_QUALIFICATION_FAILURE:
            {
                var error = action.payload.error;
                return _object_spread_props(_object_spread({}, state), {
                    currentQualificationByIdLoading: false,
                    currentQualificationByIdError: error
                });
            }
        case LOAD_QUALIFICATION_SUCCESS:
            {
                var qualification = action.payload.qualification;
                return _object_spread_props(_object_spread({}, state), {
                    currentQualificationByIdLoading: false,
                    currentQualificationByIdError: '',
                    qualificationsById: _object_spread_props(_object_spread({}, state.qualificationsById), _define_property({}, qualification.id, _object_spread({}, state.qualificationsById[qualification.id], qualification)))
                });
            }
        case LOAD_QUALIFICATIONS_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    qualificationsByIdLoading: true,
                    qualificationsByIdError: ''
                });
            }
        case LOAD_QUALIFICATIONS_SUCCESS:
            {
                var qualifications = action.payload.qualifications;
                return _object_spread_props(_object_spread({}, state), {
                    qualificationsById: _object_spread({}, state.qualificationsById, qualifications),
                    qualificationsByIdLoading: false,
                    qualificationsByIdError: ''
                });
            }
        case LOAD_QUALIFICATIONS_FAILURE:
            {
                var error1 = action.payload.error;
                return _object_spread_props(_object_spread({}, state), {
                    qualifications: _object_spread_props(_object_spread({}, state.qualifications), {
                        error: error1
                    }),
                    targetingQualifications: _object_spread_props(_object_spread({}, state.targetingQualifications), {
                        error: error1
                    }),
                    qualificationsByIdLoading: false,
                    qualificationsByIdError: error1
                });
            }
        case LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST:
            {
                var _action_payload = action.payload, countryId = _action_payload.countryId, languageId = _action_payload.languageId;
                return _object_spread_props(_object_spread({}, state), {
                    currentTargetingByCountryLanguageLoading: true,
                    currentTargetingByCountryLanguageError: '',
                    currentTargetingByCountryLanguage: {
                        countryId: countryId,
                        languageId: languageId
                    }
                });
            }
        case LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS:
            {
                var _action_payload1 = action.payload, countryId1 = _action_payload1.countryId, languageId1 = _action_payload1.languageId, targetingQualification = _action_payload1.targetingQualification;
                return _object_spread_props(_object_spread({}, state), {
                    currentTargetingByCountryLanguageLoading: false,
                    currentTargetingByCountryLanguageError: '',
                    currentTargetingByCountryLanguage: {
                        countryId: countryId1,
                        languageId: languageId1
                    },
                    targetingByCountryLanguage: _object_spread_props(_object_spread({}, state.targetingByCountryLanguage), _define_property({}, "".concat(countryId1, "-").concat(languageId1), targetingQualification))
                });
            }
        case LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE:
            {
                var error2 = action.payload.error;
                return _object_spread_props(_object_spread({}, state), {
                    targetingByCountryLanguageLoading: false,
                    targetingByCountryLanguageError: error2
                });
            }
        case LOAD_DEVELOPER_QUALIFICATIONS_REQUEST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    developerQualificationsLoading: true,
                    developerQualificationsError: ''
                });
            }
        case LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS:
            {
                var qualifications1 = action.payload.qualifications;
                return _object_spread_props(_object_spread({}, state), {
                    developerQualificationsLoading: false,
                    developerQualificationsError: '',
                    developerQualifications: qualifications1
                });
            }
        case LOAD_DEVELOPER_QUALIFICATIONS_FAILURE:
            {
                var error3 = action.payload.error;
                return _object_spread_props(_object_spread({}, state), {
                    developerQualificationsLoading: false,
                    developerQualificationsError: error3
                });
            }
        default:
            return state;
    }
}
